import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Qué pasa con la grabación de audio? ¿Es segura?",
    answer:
      "100% privada. Las grabaciones se almacenan encriptadas y solo tú como coach tienes acceso. Tus clientes solo ven los resúmenes, nunca el audio completo. Cumplimos con todas las regulaciones de protección de datos.",
  },
  {
    question: "¿Necesito equipo especial para grabar?",
    answer:
      "No. El micrófono de tu computadora, tablet o teléfono es suficiente. También se integra con videollamadas. La IA está optimizada para funcionar con audio de calidad estándar.",
  },
  {
    question: "¿La IA realmente entiende consultas nutricionales?",
    answer:
      "Sí. La IA está optimizada para el contexto nutricional y deportivo en español. Entiende términos específicos como macros, pliegues cutáneos, periodización nutricional. Y mejora con el uso.",
  },
  {
    question: "¿Qué ve mi cliente cuando le comparto el link?",
    answer:
      "Un dashboard limpio con su evolución: peso, % de grasa corporal, gráficas de progreso, fotos comparativas y puntos clave de cada consulta. NO ve la transcripción completa, tus notas privadas ni el feedback interno del coach.",
  },
  {
    question: "¿Puedo cancelar en cualquier momento?",
    answer:
      "Absolutamente. Sin contratos, sin penalizaciones. Tu acceso continúa hasta el final del período de facturación. Después tienes 90 días para exportar tus datos.",
  },
  {
    question: "¿Los precios de tokens IA pueden cambiar?",
    answer:
      "Sí, basados en los costos de nuestros proveedores de IA. Nos reservamos el derecho de ajustar precios con 30 días de anticipación. Los tokens incluidos en tu plan se mantienen.",
  },
];

export const FAQSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="faq"
      ref={ref}
      className="relative py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight"
          >
            Preguntas frecuentes
          </motion.h2>
        </div>

        {/* Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-white/10 rounded-xl px-6 bg-white/[0.02] hover:bg-white/[0.04] transition-colors data-[state=open]:border-[#E05D3A]/30"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-white hover:no-underline py-5 font-outfit font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
